import React, { Fragment } from 'react';
import { ThemeProvider } from 'styled-components';
import Sticky from 'react-stickynode';
import { DrawerProvider } from 'common/contexts/DrawerContext';
import { saasModernTheme } from 'common/theme/saasModern';
import { ResetCSS } from 'common/assets/css/style';
import {
  GlobalStyle,
  ContentWrapper,
} from 'containers/SaasModern/sassModern.style';

import { Modal } from '@redq/reuse-modal';
import '@redq/reuse-modal/es/index.css';

import BannerSection from 'containers/SaasModern/Banner';
import Navbar from 'containers/SaasModern/Navbar';
import PricingPolicy from 'containers/SaasModern/PricingPolicy';
import PartnerSection from 'containers/SaasModern/Partner';
import FaqSection from 'containers/SaasModern/Faq';
import InfoSection from 'containers/SaasModern/Info';
import FeatureSection from 'containers/SaasModern/Feature';
import ShoutoutTestimonials from 'containers/SaasModern/ShoutoutTestimonials';
import Footer from 'containers/SaasModern/Footer';
import Seo from 'components/seo';
import GetStartedSection from '../containers/SaasModern/GetStarted';
import CloudPouchSection from '../containers/SaasModern/CloudPouch';
import CaseStudiesSection from '../containers/SaasModern/CaseStudies';
import CostInsightsSection from '../containers/SaasModern/CostInsights';
import ComparisonSection from '../containers/SaasModern/Comparison';
import SavingsWorkspaceSection from '../containers/SaasModern/SavingsWorkspace';
import InteractiveDemoSection from '../containers/SaasModern/InteractiveDemo';
import AgenticFinOpsSection from '../containers/SaasModern/AgenticFinOps';
import PrivacyTrustSection from '../containers/SaasModern/PrivacyTrust';

const SaasModern = () => {
  const keywords = "AWS, billing, costs, optimization, FinOps, reduce, invoice, TCO, cloud economist".split(',');
  return (
    <ThemeProvider theme={saasModernTheme}>
      <Fragment>
        <Seo title="CloudPouch | Reduce AWS costs. Typical savings 13–44%" keywords={keywords}/>
        <Modal />
        <ResetCSS />
        <GlobalStyle />

        <ContentWrapper>
          <Sticky top={0} innerZ={9998} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>
          {/* Result before mechanics: the hero with the customer logos and
              its band of audit figures, the audit cases, then the product
              in action, and only then how it works. */}
          <BannerSection />
          <CaseStudiesSection />
          <InteractiveDemoSection />
          <SavingsWorkspaceSection />
          <CostInsightsSection />
          <ComparisonSection />
          <InfoSection />
          <AgenticFinOpsSection />
          <FeatureSection />
          <PrivacyTrustSection />
          <ShoutoutTestimonials />
          <PricingPolicy />
          <CloudPouchSection />
          <PartnerSection />
          <FaqSection />
          <GetStartedSection />
          <Footer />
        </ContentWrapper>
      </Fragment>
    </ThemeProvider>
  );
};
export default SaasModern;
